import React, { PureComponent } from 'react';


import styles from './styles';

export default class Tooltip extends PureComponent {

  render() {
    const { hint } = this.props;
    return (  
      <span className={styles.tooltipHolder}> 
          <span className={styles.tooltip}>
            ?
          </span>
          <span className={styles.tooltiptext}> 
            {hint}
          </span>
      </span>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Tooltip/index.jsx